import { render, staticRenderFns } from "./HeaderNavigationMenu.vue?vue&type=template&id=cfc2f8e4&"
import script from "./HeaderNavigationMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavigationMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports